export const actions = {
  USUARIOS_TREE_LOAD_REQUESTED: 'USUARIOS_TREE_LOAD_REQUESTED',
  USUARIOS_TREE_LOAD_SUCCEEDED: 'USUARIOS_TREE_LOAD_SUCCEEDED',
  USUARIOS_TREE_LOAD_FILED: 'USUARIOS_TREE_LOAD_FILED',

  USUARIOS_TREE_LOAD_REQUESTED_FILTERED: 'USUARIOS_TREE_LOAD_REQUESTED_FILTERED',
  USUARIOS_TREE_LOAD_SUCCEEDED_FILTERED: 'USUARIOS_TREE_LOAD_SUCCEEDED_FILTERED',
  USUARIOS_TREE_LOAD_FILED_FILTERED: 'USUARIOS_TREE_LOAD_FILED_FILTERED',

  USUARIOS_LOAD_REQUESTED: 'USUARIOS_LOAD_REQUESTED',
  USUARIOS_LOAD_SUCCEEDED: 'USUARIOS_LOAD_SUCCEEDED',
  USUARIOS_LOAD_FILED: 'USUARIOS_LOAD_FILED',

  USUARIO_LOAD_BY_ID_REQUESTED: 'USUARIO_LOAD_BY_ID_REQUESTED',
  USUARIO_LOAD_BY_ID_SUCCEEDED: 'USUARIO_LOAD_BY_ID_SUCCEEDED',
  USUARIO_LOAD_BY_ID_FILED: 'USUARIO_LOAD_BY_ID_FILED',

  USUARIO_LOAD_BY_ID_INSERT_REQUESTED: 'USUARIO_LOAD_BY_ID_INSERT_REQUESTED',

  USUARIO_UPDATE_REQUESTED: 'USUARIO_UPDATE_REQUESTED',
  USUARIO_UPDATE_SUCCEEDED: 'USUARIO_UPDATE_SUCCEEDED',
  USUARIO_UPDATE_FILED: 'USUARIO_UPDATE_FILED',

  USUARIO_PATCH_REQUESTED: 'USUARIO_PATCH_REQUESTED',
  USUARIO_PATCH_SUCCEEDED: 'USUARIO_PATCH_SUCCEEDED',
  USUARIO_PATCH_FILED: 'USUARIO_PATCH_FILED',

  USUARIO_INSERT_REQUESTED: 'USUARIO_INSERT_REQUESTED',
  USUARIO_INSERT_SUCCEEDED: 'USUARIO_INSERT_SUCCEEDED',
  USUARIO_INSERT_FILED: 'USUARIO_INSERT_FILED',

  USUARIO_DELETE_REQUESTED: 'USUARIO_DELETE_REQUESTED',
  USUARIO_DELETE_SUCCEEDED: 'USUARIO_DELETE_SUCCEEDED',
  USUARIO_DELETE_FILED: 'USUARIO_DELETE_FILED',

  USUARIO_LOAD_BY_ID_PERFIL_REQUESTED: 'USUARIO_LOAD_BY_ID_PERFIL_REQUESTED',
  USUARIO_LOAD_BY_ID_PERFIL_SUCCEEDED: 'USUARIO_LOAD_BY_ID_PERFIL_SUCCEEDED',
  USUARIO_LOAD_BY_ID_PERFIL_FILED: 'USUARIO_LOAD_BY_ID_PERFIL_FILED',

  USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_REQUESTED: 'USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_REQUESTED',
  USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_SUCCEEDED: 'USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_SUCCEEDED',
  USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_FAILED: 'USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_FAILED',

  USUARIO_LOAD_STOCK_MANAGER_REQUESTED: 'USUARIO_LOAD_STOCK_MANAGER_REQUESTED',
  USUARIO_LOAD_STOCK_MANAGER_SUCCEEDED: 'USUARIO_LOAD_STOCK_MANAGER_SUCCEEDED',
  USUARIO_LOAD_STOCK_MANAGER_FAILED: 'USUARIO_LOAD_STOCK_MANAGER_FAILED',
}

export const getUsuariosTreeAction = dispatch => {
  dispatch({
    type: actions.USUARIOS_TREE_LOAD_REQUESTED,
  })
}

export const getUsuariosTreeActionFiltered = (dispatch, filter) => {
  dispatch({
    type: actions.USUARIOS_TREE_LOAD_REQUESTED_FILTERED,
    payload: filter,
  })
}

export const getUsuariosAction = dispatch => {
  dispatch({
    type: actions.USUARIOS_LOAD_REQUESTED,
  })
}

export const getUsuarioByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.USUARIO_LOAD_BY_ID_REQUESTED,
    payload: id,
  })
}

export const getPermisosMenuKeyUsuarioByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.USUARIO_LOAD_PERMISOS_MENUKEY_BY_ID_REQUESTED,
    payload: id,
  })
}

export const getUsuarioCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.USUARIO_LOAD_BY_ID_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.USUARIO_LOAD_BY_ID_INSERT_REQUESTED,
    })
  }
}

export const onSubmitInsertUsuarioFormAction = (dispatch, formUsuario) => {
  dispatch({
    type: actions.USUARIO_INSERT_REQUESTED,
    payload: formUsuario,
  })
}

export const onSubmitUpdateUsuarioFormAction = (dispatch, formUsuario) => {
  dispatch({
    type: actions.USUARIO_UPDATE_REQUESTED,
    payload: formUsuario,
  })
}

export const patchUsuarioAction = (dispatch, id, payload, noNotificar) => {
  dispatch({
    type: actions.USUARIO_PATCH_REQUESTED,
    payload,
    id,
    noNotificar: noNotificar ?? false,
  })
}

export const deleteUsuarioAction = (dispatch, id) => {
  dispatch({
    type: actions.USUARIO_DELETE_REQUESTED,
    payload: id,
  })
}

export const getUsuarioPerfilByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.USUARIO_LOAD_BY_ID_PERFIL_REQUESTED,
    payload: id,
  })
}

export const getUsuarioStockManagerAction = dispatch => {
  dispatch({
    type: actions.USUARIO_LOAD_STOCK_MANAGER_REQUESTED,
  })
}
